export default __webpack_public_path__ + "static/media/detail_big_13_4.8b23c6cb.jpg";